module.exports = __webpack_public_path__ + "img/phone.6e730053.png";